import { FC } from 'react';

import { Container } from 'reactstrap';

import classNames from 'classnames';

import { DocumentTitle, PageTitle, PortalItem } from '@hsp/react-component-library';

import { PageLayoutProps } from '@t/c/layouts/pages/page.props';

import { t } from '@u/strings';

const PageLayout: FC<PageLayoutProps> = ({ children, className, controls, documentTitle, title, ...props }) => {
  return (
    <>
      <DocumentTitle title={documentTitle ?? t()} />
      <div
        {...props}
        className={classNames('page-content', className)}>
        <Container fluid>
          <PageTitle />
          {children}
        </Container>
      </div>
      <PortalItem portalOutletId="page-title-controls-portal">{controls}</PortalItem>
      <PortalItem portalOutletId="page-title-text-portal">{title}</PortalItem>
    </>
  );
};

export default PageLayout;
